import Amplify from 'aws-amplify';
import fetch from 'cross-fetch';

export const initAmplify = (settings: any): any => {
  const { aws } = settings.iam;

  Amplify.configure({
    Auth: {
      ...aws,
      // using USER_PASSWORD_AUTH for migration purposes
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
  });

  return aws;
};

export const pingCognito = async (awsRegion: string): Promise<boolean> => {
  try {
    const response = await fetch(`https://cognito-idp.${awsRegion}.amazonaws.com/ping`);
    const healthy = await response.text();
    return response.status === 200 && healthy === 'healthy';
  } catch {
    return false;
  }
};
